<template>
  <div class="channel-shop flex flex-column">
    <div class="relative banner-img" v-if="bannerImg">
      <van-image class="w100-full" lazy-load :src="`${bannerImg}?imageView2/1/w/750/h/300`" />
      <div class="f12 absolute white radius50 banner-btn flex items-center justify-center" @click="routerClick(bannerUrl, 'link')">申请合作</div>
    </div>
    <div class="pad5 flex-auto overflow-auto">
      <div class="mar5 pad10 radius7 shop-top" v-if="firstShop.shopIds">
        <div class="flex" @click="routerClick(`/shop/${firstShop.shopIds}`)">
          <div class="shop-img flex-shrink">
            <van-image v-if="firstShop.shopIcon" lazy-load :src="`${firstShop.shopIcon}?imageView2/1/w/100/h/100`" />
            <img v-else src="../../assets/images/shop/shop-none.png" />
          </div>
          <div class="pad10-l flex flex-auto flex-column justify-between">
            <div class="flex items-center justify-between">
              <span class="white fb flex-auto text-overflow pad10-r">{{firstShop.name}}</span>
              <span class="f10 shop-dist radius30" v-if="firstShop.showDistance && firstShop.showDistance !== '0'">{{ firstShop.showDistance }}</span>
            </div>
            <p class="f12 white text-overflow">主营：{{firstShop.businessScope}}</p>
            <div class="flex flex-wrap">
              <template v-for="(item, index) in firstShop.tagList">
                <span :key='index' class="white f10 radius30 mar5-r border pad5-lr lin15 mar5-t">{{item.name}}</span>
              </template>
            </div>
          </div>
        </div>
        <ul class="flex flex-wrap mar5-t">
          <li
            class="bg-white radius5 pad5 flex flex-column items-center justify-center"
            v-for="good in firstShop.goodsInfoList"
            :key="good.goodsId"
            @click="routerClick(`/goodDetails/${good.goodsId}`)">
            <div>
              <van-image v-if="good.goodsUrl" lazy-load :src="`${good.goodsUrl}?imageView2/1/w/75/h/60`" />
              <img v-else src="../../assets/images/good/good-none.png" />
            </div>
            <span class="w100-full text-center pad5-t f10 fb gray3 text-overflow">{{good.goodsName}}</span>
            <!-- <div class="pad5-tb text-center flex-auto">
              <span class="f10 fb gray3 text-overflow">{{good.goodsName}}</span>
              <p class="f10 fb red">¥{{good.sellFactPriceStr}}</p>
            </div> -->
          </li>
        </ul>
      </div>
      <div class="mar5-t shop-list">
        <van-list
          :loading="allGoodLoaing"
          :finished="allGoodFinished"
          :offset="10"
          finished-text="没有更多了"
          @load="onLoad">
          <ul class="ul-cls flex flex-column pad5-lr">
            <li
             class="bg-white radius5 mar10-b pad10 flex flex-auto"
              v-for="item in shopList"
               :key="item.shopIds"
                 @click="routerClick(`/shop/${item.shopIds}`)">
              <div class="shop-img flex-shrink">
                <van-image v-if="item.shopIcon" lazy-load :src="`${item.shopIcon}?imageView2/1/w/100/h/100`" />
                <img v-else src="../../assets/images/shop/shop-none.png" />
              </div>
              <div class="pad15-l flex flex-auto flex-column justify-between">
                <div class="flex items-center justify-between">
                  <span class="gray3 fb flex-auto text-overflow pad10-r">{{ item.name }}</span>
                  <span class="f10 shop-dist radius30" v-if="item.showDistance && item.showDistance !== '0'">{{ item.showDistance }}</span>
                </div>
                <p class="f12 gray6 text-overflow">主营：{{ item.businessScope }}</p>
                <div class="flex flex-wrap">
                  <span class="red f10 radius30 mar5-r mar5-t border pad5-lr lin15" v-if="item.isnxyy === '1'">运营中心</span>
                  <span class="green f10 radius30 mar5-r mar5-t border pad5-lr lin15" v-if="item.isDealership === '1'">经销店</span>
                  <span class="blue f10 radius30 mar5-r mar5-t border pad5-lr lin15" v-if="item.isFactoryDirect === '2'">厂家品牌店</span>
                  <span class="green f10 radius30 mar5-r mar5-t border pad5-lr lin15" v-if="item.isNongxinStation === '1'">农信小站</span>
                  <span class="orange f10 radius30 mar5-r mar5-t border pad5-lr lin15" v-if="item.isCoreEnterprise === '1'">核心企业旗舰店</span>
                </div>
              </div>
            </li>
          </ul>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
// import wx from 'weixin-js-sdk';
import common from "../../assets/js/common";

export default {

  data() {
    return {
      bannerUrl: "",
      bannerImg: "",
      lat: "", // 39.662263
      lon: "", // 118.197815
      pageNum: 1,
      pageTotal: 1,
      shopType: 1, // 1(运营中心) 2（农信小站）3（品牌企业）
      firstShop: {},
      shopList: [],
      allGoodLoaing: false,
      allGoodFinished: false
    };
  },
  created() {
    const { shopType } = this.$route.query;
    this.shopType = shopType || "1";
    if (this.shopType === "1") {
      this.bannerUrl = "https://zntm.nxin.com/h5/intelligent/detail?NumericalOrder=2109092011420000117";
      this.bannerImg = "https://cmscenter-files.nxin.com/nxsc/channel/yyzx_new.jpg";
    } else if (this.shopType === "2") {
      this.bannerUrl = "https://zntm.nxin.com/h5/intelligent/detail?NumericalOrder=2109092011420000117";
      this.bannerImg = "https://cmscenter-files.nxin.com/nxsc/channel/nxxz.jpg";
    } else if (this.shopType === "3") {
      this.bannerUrl = "https://zntm.nxin.com/h5/intelligent/detail?NumericalOrder=2203081609320000115";
      this.bannerImg = "https://cmscenter-files.nxin.com/nxsc/channel/ppqy_new.jpg";
    }
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 0
    });
  },
  mounted() {
    this.getLocation();
  },
  methods: {
    onLoad() {
      const { pageNum, pageTotal, shopList } = this;
      if (pageNum > pageTotal || !shopList.length) { return; }
      this.pageNum += 1;
      this.allGoodLoaing = true;
      this.getList();
    },
    getList() {
      const {
        lat, lon, pageNum, shopType
      } = this;
      this.$store.dispatch("channel/getzntScShopList", {
        lat,
        lon,
        pageNum,
        shopType
      }).then((res) => {
        console.log("获取到的店铺", res);
        const { list, total } = res;
        if (pageNum === 1) {
          if (list.length) {
            // eslint-disable-next-line tagList
            const tagList = [];
            const firstShop = list[0];
            const {
              isnxyy, isDealership, isFactoryDirect, isNongxinStation, isCoreEnterprise
            } = firstShop;
            if (isnxyy === "1") { tagList.push({ name: "运营中心" }); }
            if (isDealership === "1") { tagList.push({ name: "经销店" }); }
            if (isFactoryDirect === "2") { tagList.push({ name: "厂家品牌店" }); }
            if (isNongxinStation === "1") { tagList.push({ name: "农信小站" }); }
            if (isCoreEnterprise === "1") { tagList.push({ name: "核心企业旗舰店" }); }
            firstShop.tagList = tagList;
            this.firstShop = firstShop;

            this.shopList = list.slice(1, list.length);
          }
        } else {
          this.shopList = [...this.shopList, ...list];
        }
        this.pageTotal = Math.ceil(total / 6);
        this.allGoodLoaing = false;
        if (pageNum >= this.pageTotal) {
          this.allGoodFinished = true;
        }
      }).finally(() => {
        Toast.clear();
      });
    },
    getLocation() {
      const that = this;
      if (isInZnt()) {
        znt.getLocation({
          success(res) {
            const { lat, lng } = res;
            that.lat = lat;
            that.lon = lng;
            that.getList();
          },
          fail(res) {
            that.getList();
            console.log("智农通获取经纬度失败", res);
          }
        });
      } else if (common.isInWeiXin()) {
        // 微信环境下获取有延迟
        setTimeout(() => {
          wx.getLocation({
            type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success(res) {
              const { latitude, longitude } = res;
              console.log("微信获取经纬度", res);
              that.lat = latitude;
              that.lon = longitude;
              that.getList();
            },
            fail(res) {
              that.getList();
              console.log("微信获取经纬度失败", res);
            }
          });
        }, 500);
      } else {
        that.getList();
      }
    },
    // 点击跳转
    routerClick(url, type) {
      if (type === "link") {
        window.location.href = url;
      } else {
        this.$router.push(url);
      }
    }

  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
